import type { ElementType, ReactNode } from "react";
import styles from "./GradientHeading.module.css";

export type GradientTone = "blue" | "amber";

export interface GradientHeadingProps {
  children: ReactNode;
  tone?: GradientTone;
  as?: ElementType;
  className?: string;
}

export function GradientHeading({
  children,
  tone = "blue",
  as: Tag = "h2",
  className,
}: GradientHeadingProps) {
  return (
    <Tag className={[styles.heading, styles[tone], className].filter(Boolean).join(" ")}>
      {children}
    </Tag>
  );
}
